// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"35":"68bcc513","531":"b59e0efe","697":"488edd59","752":"6ec0c258","770":"f7ec4151","813":"3e3bb13b","844":"5a91ae9c","960":"5b843ff8"}[chunkId] + ".js";
};